import { ChangeEvent, forwardRef, useCallback } from 'react';

import { BaseTextField, BaseTextFieldProps } from './BaseTextField';

export interface NumberFieldProps
    extends Omit<BaseTextFieldProps, 'onChange' | 'value' | 'defaultValue' | 'type'> {
    value?: number | string;
    defaultValue?: number | string;
    min?: number;
    max?: number;
    step?: number;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const NumberField = forwardRef<HTMLInputElement, NumberFieldProps>(
    ({ value, defaultValue, min, max, step = 1, onChange, ...props }, ref) => {
        const handleChange = useCallback(
            (event: ChangeEvent<HTMLInputElement>) => {
                const inputValue = event.target.value;

                onChange?.(event);
            },
            [onChange],
        );

        // Convert number values to strings for BaseTextField
        const stringValue = value !== undefined ? String(value) : undefined;
        const stringDefaultValue = defaultValue !== undefined ? String(defaultValue) : undefined;

        return (
            <BaseTextField
                {...props}
                ref={ref}
                type="number"
                value={stringValue}
                defaultValue={stringDefaultValue}
                min={min}
                max={max}
                step={step}
                onChange={handleChange}
            />
        );
    },
);

NumberField.displayName = 'NumberField';

export default NumberField;
